
import React, { useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SearchBar from "@/components/SearchBar";
import ShopHero from "@/components/shop/ShopHero";
import ProductsGrid from "@/components/shop/ProductsGrid";
import BenefitsSection from "@/components/shop/BenefitsSection";
import { products } from "@/components/shop/ShopTypes";

const Shop = () => {
  const [searchQuery, setSearchQuery] = useState("");
  
  // Filter products based on search query
  const filteredProducts = products.filter(product => 
    product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    product.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Handler to clear search
  const handleClearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <ShopHero />

        {/* Featured Products Section */}
        <section className="py-16">
          <div className="container-custom">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-3">Products We Recommend</h2>
              <p className="text-muted-foreground max-w-2xl mx-auto mb-8">
                Our team has personally tested and vetted these trusted products for your underarm health.
              </p>
              
              {/* Search Bar */}
              <div className="mb-10">
                <SearchBar 
                  value={searchQuery} 
                  onChange={setSearchQuery} 
                  placeholder="Search for products..." 
                />
              </div>
            </div>

            {/* Products Grid */}
            <ProductsGrid 
              products={filteredProducts}
              searchQuery={searchQuery}
              onClearSearch={handleClearSearch}
            />
          </div>
        </section>

        {/* Benefits Section */}
        <BenefitsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Shop;
